<template>
  <div v-longtouch="(longTouchEvent, changeStyle)">
    <div class="content-body">
      <div
        v-if="data.content"
        :id="`text_${data.id}`"
        ref="commentContent"
        class="content-text comment-content-all" :class="[
          contentSpacing,
          secondCommentClass,
        ]"
      >
        <span v-if="parentReplyNickname && isShowQuote && !isSameSubLevel"> 回复 <span class="parent-reply-name">{{ parentReplyNickname }}</span>： </span>
        <TextClamp :text="data.content" :max-lines="5" :auto-resize="true" @update:dis-height="onChangeDisHeight">
          <template #after="{ toggle, expanded, clamped }">
            <div v-if="expanded || clamped" class="content-more-box" @click.stop="toggle">
              <span class="content-more">{{ !expanded ? '展开' : '收起' }}</span>
              <span class="expand-icon">
                <component :is="expandIconName" :is-rotate="expanded" />
              </span>
            </div>
          </template>
        </TextClamp>
      </div>
    </div>
    <div v-if="attachment" class="content-img">
      <div class="img-box">
        <img
          v-lazyload="{
            realUrl: attachment,
            defaultUrl: isNightMode ? imgDefaultDark : imgDefault,
            errUrl: isNightMode ? imgErrorDark : imgError,
          }"
          alt="[动图]"
        >
      </div>
    </div>
    <!-- <div v-if="parentReplyNickname && isShowQuote && isCommentSecondDetailReply" class="quote">
      <div class="content-quote">
        @{{ parentReplyNickname }}：
        <span v-if="noDelContent"
          ><span :id="'text_' + data.id">{{ body }}</span
          >{{ imgExtraContent }}</span
        >
        <span v-else>原内容已删除</span>
      </div>
    </div> -->
  </div>
</template>

<script lang="ts">
import { computed, ref, defineComponent, toRefs } from 'vue';
import { constant, utils, eventBus } from '@cpc/comment-sdk-common';
import { useGlobalState } from '@cpc/comment-sdk-core-comment';

// import { setTopicContent } from '../core/useTopicContent/index';
import { commonCommentStat } from '../core/useStat';
import { useOnCommentClickInject } from '../core/useOnCommentClickProvide/index';
import { useMsgCenterSub } from '../core/useMsgCenterSub/index';
import imgDefault from '../assets/img/img_loading.png';
import imgDefaultDark from '../assets/img/img_loading_dark.png';
import imgError from '../assets/img/img_load_error.png';
import imgErrorDark from '../assets/img/img_load_error_dark.png';

import ExpandIcon from './ExpandIcon/bright.vue';
import ExpandIconDark from './ExpandIcon/dark.vue';

import TextClamp from './TextClamp/index.vue';

export default defineComponent({
  name: 'ContentBody',

  components: {
    ExpandIcon,
    ExpandIconDark,
    TextClamp,
  },

  props: {
    commentOwner: {
      type: Object,
      default() {
        return {};
      },
    },
    type: {
      type: String,
      default() {
        return '';
      },
    },
    isSecondDetailComment: {
      type: String,
      default() {
        return '';
      },
    },
    data: {
      type: Object,
      default() {
        return {};
      },
    },
    isShowQuote: {
      type: Boolean,
      default: true,
    },
    subCommentId: {
      type: String,
      default() {
        return '';
      },
    },
    isSecondCommentDetail: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['update:disHeight'],

  setup(props, { emit }) {
    const { PageType } = constant;
    const { pageType, userMeta, isNightMode } = toRefs(useGlobalState());

    const { data, commentOwner, type, subCommentId, isSecondCommentDetail, isSecondDetailComment } = toRefs(props);

    const { onCommentClickThrottle } = useOnCommentClickInject();

    const { isFromMsgCenter } = useMsgCenterSub();

    const commentContent = ref(null);

    // 内容包含图片
    const attachment = computed(() => data.value.imageList && data.value.imageList[0]);

    const parentOwner = ref(data.value.parentReply && data.value.parentReply.owner);

    const body = computed(() => data.value.parentReply && data.value.parentReply.content);

    const imgExtraContent = computed(() => {
      return data.value.parentReply.imageList && data.value.parentReply.imageList.length > 0
        ? '[动图]'
        : '';
    });

    const expandIconName = computed(() => {
      return isNightMode.value ? 'ExpandIconDark' : 'ExpandIcon';
    });

    const noDelContent = computed(() => {
      return body.value || imgExtraContent;
    });

    const contentSpacing = computed(() => {
      return isSecondDetailComment.value === 'comment' ? 'reply-spacing' : type.value === 'comment' ? 'comment-spacing' : 'reply-spacing';
    });

    const secondCommentClass = computed(() => {
      return isCommentSecondDetailReply.value ? 'second-comment' : '';
    });

    const parentReplyNickname = computed(
      () =>
        parentOwner.value
        && (parentOwner.value.id !== commentOwner.value.id
          || commentOwner.value.id === userMeta.value.uid)
        && parentOwner.value.nickname,
    );

    const isCommentSecondDetailReply = computed(() => {
      return pageType.value === PageType.SECOND_COMMENT_DETAIL && isSecondCommentDetail.value;
    });

    const isSameSubLevel = computed(() => {
      console.log('subCommentId.value', subCommentId.value);
      console.log('subCommentId.value data', data.value.parentReply.id);
      return isFromMsgCenter.value && subCommentId.value === data.value.parentReply.id;
    })

    const isAllowLongTouch = ref(true);

    eventBus.on('IS_ALLOW_PASTE', (isAllow: boolean) => {
      isAllowLongTouch.value = isAllow;
    })

    const longTouchEvent = () => {
      commonCommentStat(20084701);

      if (isAllowLongTouch.value) {
        onCommentClickThrottle(props.data, {
          directReport: true,
        });
      }
      setTimeout(() => {
        changeStyle(false);
      });
    };

    const changeStyle = (isShow: boolean) => {
      const idElement = type.value === 'comment' ? '#feedback_' : '#reply_';

      if (isShow) {
        utils?.$(idElement + data.value.id)?.classList.add('touch-feed-back');
      } else {
        utils?.$(idElement + data.value.id)?.classList.remove('touch-feed-back');
      }
    };

    const onChangeDisHeight = (disHeight: number) => {
      emit('update:disHeight', disHeight);
    };

    return {
      data,
      commentContent,

      attachment,
      parentReplyNickname,

      PageType,
      pageType,

      isCommentSecondDetailReply,

      longTouchEvent,
      changeStyle,

      body,
      imgExtraContent,
      noDelContent,
      contentSpacing,
      secondCommentClass,

      isSameSubLevel,

      imgDefault,
      imgDefaultDark,
      imgError,
      imgErrorDark,
      isNightMode,

      expandIconName,

      onChangeDisHeight,
    };
  },
});
</script>

<style lang="scss" scoped>
@import '../assets/css/styling-mixin.scss';

.content-body {
  font-size: 42px;
  // display: flex;
}

.content-img {
  margin-top: 30px;
  margin-bottom: 12px;
  width: 450px;
  height: 450px;
  position: relative;

  .img-box {
    position: absolute;
    top: 50%;
    left: 50%;

    transform: translate(-50%, -50%);
  }
  img {
    border-radius: 48px;
    max-width: 450px;
    max-height: 450px;
  }
}

.content-text {
  font-size: 42px;
  // word-break: break-word;

  overflow: hidden;
  text-overflow: ellipsis;
  text-align: justify;
  line-height: 60px;
  position: relative;

  display: -webkit-box;
  -webkit-box-orient: vertical;
  color: rgba($color: #000, $alpha: 0.9);
 @include os-browser-styling('', '', false, false, true, true) {
    color: rgba($color: #fff, $alpha: 0.9);
  }
  &.comment-content-fold::before {
    content: '';
    float: right;
    width: 0;
    height: 100%;
    margin-bottom: var(--height);
  }
  &.comment-content-all {
    max-height: 9999px;
  }
}

.second-comment {
  font-size: 48px;
}

.parent-reply-name {
  color: rgba($color: #000, $alpha: 0.4);
  font-size: 42px;
  @include os-browser-styling('', '', false, false, true, true) {
    color: rgba($color: #fff, $alpha: 0.4);
  }
}

.more-content {
  display: flex;
  align-items: center;
  margin-top: 12px;
}

.content-more-box {
  display: inline-flex;
  height: 48px;
  line-height: 48px;
  margin-left: 12px;

  @include extend(2, 2);
}

.content-more {
  display: inline-block;
  font-size: 36px;
  height: 48px;
  color: rgba($color: #000, $alpha: 0.54);
  font-weight: 500;
  @include os-browser-styling('', '', false, false, true, true) {
    color: rgba($color: #fff, $alpha: 0.54);
  }
}

.expand-icon {
  display: inline-block;
  width: 48px;
  height: 48px;
}

.comment-spacing {
  margin: 12px 0;
}

.reply-spacing {
  margin: 12px 0;
}

.quote {
  width: auto;
  background: rgba(0, 0, 0, 0.04);
  border-radius: 30px;

  color: rgba(0, 0, 0, 0.55);

  padding: 24px 48px;
  margin: 30px 0 0 0;
}

.content-quote {
  max-height: 130px;

  font-weight: 500;
  font-size: 42px;
  line-height: 60px;

  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

:deep(.topic-tag) {
  color: rgba(38, 96, 245, 1);
  font-weight: normal;
  text-decoration: none;
  -webkit-tap-highlight-color: rgba(255, 255, 255, 0);
}

html[data-theme='dark'] {
  .content-body {
    color: rgba(255, 255, 255, 0.9);
  }

  .reply-owner {
    opacity: 0.55;
  }

  .quote {
    background: #f5f5f5;
    color: rgba(255, 255, 255, 0.85);
  }

  .content-quote {
    opacity: 0.85;
  }
}
</style>
